import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

eventBus.on('user wants to see whole progression', function () {
    let lastLevelID

    eventBus.on('challenge view ready', function (challenge) {
        if (lastLevelID !== challenge.levelID) {
            lastLevelID = challenge.levelID
            $('<h1 class="level_name">' + levelLink(lastLevelID) + '</h1>').insertBefore(challenge.container)
        }
    })
})

const dir = '/Users/plancien/dev/toxicode/pedagogie/silent_teacher'

function levelLink (levelID) {
    return '<a tabindex="-1" href="txmt://open?url=file://' + dir + '/scripts/levels/' +
            levelID +
            '.js">' + levelID + '</a>'
}

if (window.location.hostname === 'localhost') {

    eventBus.on('level changed', function (levelID) {
        $('#level_name').html(levelLink(levelID) + ' (debug)')
    })

    eventBus.on('step completed', function () {
        $('#level_name').html('')
    })
}

